import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import config from 'config';
import Section from 'components/Section';
import { Paper } from '@mui/material';

import './Dictionary.css';
import { useSelector } from 'react-redux';
import { getAllTerms } from 'utils/dictionary';
import { translation } from 'utils/translate';

/* COMPONENT FOR Dictionary / sanakirja */
const Dictionary = () => {
  // scroll to top when entering page view
  useEffect(() => window.scrollTo(0, 0), []);

  const lang = useSelector((store) => store.lang);

  const terms = getAllTerms(lang);

  return (
    <>
      <Helmet>
        <title>
          {translation('lainvalmistelun_sanakirja', lang)}
          {' | '}
          {config.site.name}
        </title>
      </Helmet>
      <Section className="section--page">
        <Paper elevation={0}>
          <div className="page-wrapper">
            <h1 className="page-title">
              {translation(
                'lainvalmistelun_sanakirja',
                lang,
              )}
            </h1>

            {terms.map((term) => (
              <React.Fragment key={term.term}>
                <h3 id={term.term}>
                  {term.term}
                  <span style={{ fontSize: '1.0rem' }}>
                    &nbsp;
                    {term.translation}
                  </span>
                </h3>
                <p>{term.explanation}</p>
                <p>
                  {term.source_text && (
                    <>
                      {translation(
                        'sanakirja_source',
                        lang,
                      )}
                      {term.source_text}
                    </>
                  )}
                  {/* line break if both text and url exist */}
                  {term.source_text && term.source_url && (
                    <br />
                  )}
                  {term.source_url && (
                    <a
                      href={term.source_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {term.source_url}
                    </a>
                  )}
                </p>
              </React.Fragment>
            ))}
          </div>
        </Paper>
      </Section>
    </>
  );
};

export default Dictionary;
